export default "__VITE_ASSET__DX$7JX7m__"